export enum CupStatus {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
	DELETED = "DELETED",
}

export interface ICup {
	_id: string;
	accountId: string;
	name: string;
	vendor: string;
	display: string;
	description: string;
	analytes: string[] | IAnalyteInCup[];
	status: CupStatus;
	isDeleted: boolean;
	createdBy: string;
	updatedBy?: string;
	createdAt: Date;
	updatedAt: Date;
}

export interface CupResponse extends Omit<ICup, "analytes"> {
	analytes: IAnalyteInCup[];
}

export interface IAnalyteInCup {
	_id: string;
	shortname: string;
	scientificName: string;
	shortnameDisplay: string;
	scientificDisplay: string;
	type: string;
}

export interface CupsResponse {
	statusCode: number;
	body: CupResponse[];
}

export interface CupsPaginatedResponse {
	statusCode: number;
	body: {
		data: CupResponse[];
		pagination: {
			currentPage: number;
			pageSize: number;
			totalCount: number;
			totalPages: number;
		};
	};
}

/**
 * SIMS-8850 — what a cup would break if it were deleted.
 *
 * COUNTS ONLY. `visits` is derived from clinical visit records, so nothing below the aggregate
 * may cross this boundary: no visit, enrollment or participant identifier (NFR-4, compliance C-2,
 * TestRail C17874). The endpoint is shaped to make that structural rather than a discipline.
 */
export interface CupDependencies {
	visits: number;
	treatmentPlans: number;
}
